export const GET_REGION = 'REGION/get_region';
export const UPDATE_REGION = 'REGION/update_region';
export const CREATE_REGION = 'REGION/create_region';
export const REMOVE_REGION = 'REGION/remove_region';
export const GET_SELECTED_REGION = 'REGION/get_selected_region';

export const GET_NATURE_BUSINESS = 'NATURE_BUSINESS/get_nature_business';
export const UPDATE_NATURE_BUSINESS = 'NATURE_BUSINESS/update_nature_business';
export const CREATE_NATURE_BUSINESS = 'NATURE_BUSINESS/create_nature_business';
export const REMOVE_NATURE_BUSINESS = 'NATURE_BUSINESS/remove_nature_business';

export const FORM_DATA = {
  name: '',
  description: '',
};

export const FORM_DATA_NATURE_BUSINESS = {
  code: '',
  name: '',
  description: '',
};
